export default {
  en: {
    'components.summary-table-ecsl.header.jurisdiction': 'Jurisdiction',
    'components.summary-table-ecsl.header.vat-number': 'VAT number',
    'components.summary-table.header.total-net': 'Total Net',
    'components.summary-table-ecsl.header.number-transactions': 'Transactions',

    'components.summary-table-ecsl.row.total': 'Total',
  },
};
